export default __webpack_public_path__ + "static/media/BannerTop.68d803b1.png";